import { render, staticRenderFns } from "./SocialMediaPost.vue?vue&type=template&id=0eb2e1d9&scoped=true&"
import script from "./SocialMediaPost.vue?vue&type=script&lang=js&"
export * from "./SocialMediaPost.vue?vue&type=script&lang=js&"
import style0 from "./SocialMediaPost.vue?vue&type=style&index=0&id=0eb2e1d9&lang=scss&scoped=true&"
import style1 from "./SocialMediaPost.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb2e1d9",
  null
  
)

export default component.exports